module.exports = __webpack_public_path__ + "static/media/overlay-indicator.66a08d8e.svg";